module.exports = __webpack_public_path__ + "img/img_4.4cdf0849.png";